import { createHttpClient } from './createHttpClient';

// In prod mode we send requests directly
const adapter = 'fetch';

const meiliHttpClient = createHttpClient({ adapter });

export { meiliHttpClient };
